import * as tslib_1 from "tslib";
export function forEachName(object, map) {
    return Object
        .keys(object)
        .map(function (key) { return ({ key: key, value: map(key) }); })
        .reduce(function (acc, line) {
        return (tslib_1.__assign({}, acc, (_a = {}, _a[line.key] = line.value, _a)));
        var _a;
    }, {});
}
export function getMaxMatch(mediaRules, matches) {
    var keys = Object.keys(mediaRules);
    var len = keys.length;
    var index = 0;
    for (; index < len; index++) {
        if (matches[keys[index]]) {
            break;
        }
    }
    return keys[index];
}
export function pickMediaMatch(mediaRules, matches, slots) {
    var keys = Object.keys(mediaRules);
    var len = keys.length;
    var index = 0;
    for (; index < len; index++) {
        if (matches[keys[index]]) {
            break;
        }
    }
    for (; index >= 0; index--) {
        var value = slots[keys[index]];
        if (value !== undefined) {
            return value;
        }
    }
    return undefined;
}
export function pickMatchValues(points, props) {
    return Object
        .keys(props)
        .reduce(function (acc, key) {
        if (points[key] !== undefined) {
            acc[key] = props[key];
        }
        return acc;
    }, {});
}
export function inBetween(breakPoints, points, value, invert, include) {
    var pass = false;
    return Object
        .keys(breakPoints)
        .reduce(function (acc, key) {
        if (invert && points[key]) {
            pass = true;
        }
        acc[key] = (include ? pass : !pass) ? null : value;
        if (!invert && points[key]) {
            pass = true;
        }
        return acc;
    }, {});
}
export function nothingSet(matches) {
    return Object
        .keys(matches)
        .reduce(function (acc, key) {
        acc[key] = false;
        return acc;
    }, {});
}
export function notNulls(matches) {
    return Object
        .keys(matches)
        .reduce(function (acc, key) {
        if (matches[key] !== undefined) {
            acc[key] = matches[key];
        }
        return acc;
    }, {});
}
